import typeToReducer from 'type-to-reducer';

import {
  ADD_GLOBAL_ERROR,
  REMOVE_GLOBAL_ERROR,
  SELECT_MONTHLY_PAYMENT_MODE,
  START_LOADER,
  STOP_LOADER,
  UPDATE_ACTIVE_IDS,
  SELECT_ANNUAL_PAYMENT_MODE,
  PaymentMode,
  UPDATE_PERMANENT_POLICY_ESTIMATE,
  SET_HAS_EMAIL,
} from 'containers/App/constants';
import fetchQueryParams from 'routes/utils/fetchQueryParams';

import reduceQueryParams from './reduceQueryParams';
import { IReduxState, AppAction } from './types';

export const initialState: IReduxState = {
  activeLifeApplicationId: '',
  activeUserUuid: '',
  error: null,
  hasEmail: false,
  lifeApplicationReferenceId: '',
  marketingCampaignId: null,
  loading: false,
  paymentMode: {},
  permanentPolicyEstimate: null,
  queryParams: reduceQueryParams(fetchQueryParams(window.location.search)),
};

export default typeToReducer<IReduxState>(
  {
    [ADD_GLOBAL_ERROR]: (state, { payload }: AppAction) => ({ ...state, error: payload }),
    [REMOVE_GLOBAL_ERROR]: (state) => ({ ...state, error: null }),
    [SELECT_ANNUAL_PAYMENT_MODE]: (state, { payload }: AppAction) => ({
      ...state,
      paymentMode: { ...state.paymentMode, [payload]: PaymentMode.YEARLY },
    }),
    [SELECT_MONTHLY_PAYMENT_MODE]: (state, { payload }: AppAction) => ({
      ...state,
      paymentMode: { ...state.paymentMode, [payload]: PaymentMode.MONTHLY },
    }),
    [START_LOADER]: (state) => ({ ...state, loading: true }),
    [STOP_LOADER]: (state) => ({ ...state, loading: false }),
    [UPDATE_ACTIVE_IDS]: (state, { payload }: AppAction) => ({ ...state, ...payload }),
    [UPDATE_PERMANENT_POLICY_ESTIMATE]: (state, { payload }: AppAction) => ({
      ...state,
      permanentPolicyEstimate: payload,
    }),
    [SET_HAS_EMAIL]: (state) => ({ ...state, hasEmail: true }),
  },
  initialState
);
